import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import { can } from 'app/helpers/can';
import { Params } from 'app/types';
import AgencyProfileIcon from 'app/ui/icons/AgencyProfileIcon';
import BookingsIcon from 'app/ui/icons/BookingsIcon';
import DashboardIcon from 'app/ui/icons/DashboardIcon';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import MessagingIcon from 'app/ui/icons/MessagingIcon';
import PaymentsIcon from 'app/ui/icons/PaymentsIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import ReviewsIcon from 'app/ui/icons/ReviewsIcon';
import SettingsIcon from 'app/ui/icons/SettingsIcon';
import CertificatesMenuIcon from 'app/ui_v2/icons/CertificatesMenuIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';
import WindowBookmarkIcon from 'app/ui_v2/icons/WindowBookmarkIcon';

const agencyGuideUrl = assetUrl(
  '../../../Tertius_User_Guide_for_Third-Party_Agencies_12.22.22.pdf'
);

export const getAgencyNavigation = (
  user: AppNS.User
): AppNS.NavigationElement[] => [
  {
    id: 'dashboard',
    name: 'Dashboard',
    url: '/agency/dashboard',
    path: '/agency/dashboard',
    icon: <DashboardIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'bookings',
    name: 'Projects',
    url: '/agency/bookings',
    path: '/agency/bookings',
    icon: <BookingsIcon />,
    disabled: false,
    // !ifAgencyCompletedFirstMilestone(user) &&
    // !ifAgencyDuringOnboarding(user),
    show: true,
    main: true,
  },
  {
    id: 'inspections',
    name: 'Inspections',
    url: '/agency/inspections/upcoming',
    path: '/agency/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/agency/messaging',
    path: '/agency/messaging/inbox',
    icon: <MessagingIcon />,
    disabled: false,
    show: can(user, 'manage_projects'),
  },
  {
    id: 'payments',
    name: 'Payments',
    url: '/agency/payments/payments-list',
    path: '/agency/payments',
    icon: <PaymentsIcon />,
    disabled: false,
    show: can(user, 'view_company_payments'),
  },
  {
    id: 'reviews',
    name: 'Reviews',
    url: '/agency/reviews',
    path: '/agency/reviews',
    icon: <ReviewsIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile'),
  },
  {
    id: 'account',
    name: 'Profile',
    url: '/agency/account',
    path: '/agency/account',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: agencyGuideUrl,
    path: agencyGuideUrl,
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'agency_profile',
    name: 'Agency & Users',
    url: '/agency/profile/main',
    path: '/agency/profile/:id',
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile'),
    settings: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/agency/settings',
    path: '/agency/settings',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getElevatorsAgencyNavigation = (
  user: AppNS.User
): AppNS.NavigationElement[] => [
  {
    id: 'elevatorsProjects',
    name: 'Projects',
    url: '/agency/elevators/projects',
    path: '/agency/elevators/projects',
    icon: <WindowBookmarkIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsCertificates',
    name: 'Certificates',
    url: '/agency/elevators/certificates',
    path: '/agency/elevators/certificates',
    icon: <CertificatesMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsInspections',
    name: 'Inspections',
    url: '/agency/elevators/inspections',
    path: '/agency/elevators/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/client/messaging/inbox',
    path: '/client/messaging',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'account',
    name: 'Profile',
    url: '/agency/account',
    path: '/agency/account',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'agency_profile',
    name: 'Agency & Users',
    url: '/agency/profile/main',
    path: '/agency/profile/:id',
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile'),
    settings: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/agency/settings',
    path: '/agency/settings',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getAgencyApps = (): Params[] => [
  {
    id: 'third-party',
    name: '3rd Party Inspections',
    homeUrl: '/agency/dashboard',
  },
  // {
  //   id: 'elevators',
  //   name: 'Elevators',
  //   homeUrl: '/elevators',
  // },
];

export const getBackOfficeApps = (): Params[] => [
  {
    id: 'dcra-inspections',
    name: 'DCRA Inspections',
    homeUrl: '/dcra-inspections/inspections',
  },
  // {
  //   id: 'elevators',
  //   name: 'Elevators',
  //   homeUrl: '/elevators',
  // },
];
